import { WorkflowType } from "../../../../shared/types/workflow";

export const WORKFLOW_NAME_KEY = 'name';
export const WORKFLOW_TYPE_KEY = 'type';

const WorkflowBlurbs = {
  [WorkflowType.BLANK]: '',
  [WorkflowType.INDICATOR_PRIORITIZATION]: 'Indicator Prioritization is an intelligence workflow that takes Indicators from selected sources and prioritizes them using normalized indicator scores and attributes, filters them by specific factors, and transforms the data to allow filtering by priority scores and indicator type, and then sends the Indicators to either a destination Enclave or a Workflow application.',
};

export const ShowWorkflowTypeExplanationBlurb = () => {
  return WorkflowBlurbs.INDICATOR_PRIORITIZATION;
}

export const WORKFLOW_NAME_MAX_CHARACTERS = 120;
